export const SlbOceanPlpPageTemplate = {
    slots: ['SlbOceanPlpSlot'],  
};
 
export const SlbOceanPlpFeaturePageTemplate = {
    slots: ['SlbOceanPlpFeatureSlot'],  
};